import { connect } from 'react-redux';
import StaffPickSection from './staff_pick_section';
import withPGTranslation from '../../../../config/withPGTranslation';
import { authPendingAction, displayRegister } from '../../../../actions/auth';
import { displayNotifyMe } from '../../../../actions/notify_me';
import { updateNavigationStack } from '../../../../actions/application';
import { withAnalytics } from '../advisor_preview/advisor_preview_with_analytics';
import { trackBEvent } from '../../../../actions/b_events';

const mapStateToProps = (state, props) => (
  {
    advisor: props.content?.advisor,
    userXfmProgram: state.user?.user?.xfmProgram,
    ...props
  }
);

export default connect(
  mapStateToProps,
  {
    displayNotifyMe,
    authPendingAction,
    displayRegister,
    updateNavigationStack,
    trackBEvent
  }
)(withPGTranslation(withAnalytics(StaffPickSection)));
